<template>
  <CustomCallout
    :has-toggle="true"
    :opened="isCancelOpen"
    class="mt-2 deep"
    :border-color="getRequestStatusColor(value.statusId)"
  >
    <div class="row mt-2 pb-3">
      <div
        class="col-md-2 col-lg-2 pt-3 pl-q"
        :class="{
          'divider-horizontal': !isMobile,
          'divider-vertical': isMobile
        }"
      >
        <div class="row h-50" :class="{ 'pr-3 float-left': isMobile }">
          <div>
            <custom-balloon
              class="px-3"
              :text="value.status"
              :background-color="
                `${getRequestStatusColor(value.statusId)} color-black`
              "
            />
          </div>
        </div>
        <div class="row mt-1">
          <div class="col" :class="{ qpl: isMobile }">
            {{ value.status !== "Nuevo" ? value.number : "-" }}
          </div>
        </div>
      </div>
      <div class="col-md-8 col-lg-8 pt3">
        <div :class="['row', { 'pt-2': isMobile }]">
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              Tipo de Asistente:
            </div>
            <p class="info-text">
              {{ value.assistantType }}
            </p>
          </div>
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              Región:
            </div>
            <p class="info-text">
              {{ value.region }}
            </p>
          </div>
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              Centro:
            </div>
            <p class="info-text">
              {{ value.center }}
            </p>
          </div>
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              Municipio:
            </div>
            <p class="info-text">
              {{ value.municipality }}
            </p>
          </div>
          <div class="col-md-4 col-12">
            <div class="info-text-title">
              Escuela:
            </div>
            <p class="info-text">
              {{ value.school }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-2 pt-3">
        <div class="row w-100 custom-button">
          <dropdown
            :class="['w-100', { 'pl-c': isMobile }]"
            name="Actions"
            :title="'Acciones'"
            :items="getHRRequestActions(value)"
          />
        </div>
      </div>
    </div>
    <template v-if="!isCancelOpen" #edition>
      <div class="additional-container">
        <div class="p2 mt-1">
          <div class="bg-gray p-2">
            <div class="bg-white p-3 rounded pl-c-xl">
              <custom-tab
                content-class="mt-3"
                :no-nav-style="true"
                nav-class="nav-vue-underline"
              >
                <custom-tab-item class="mt-2" title="Información General">
                  <span class="mt-1">
                    <i class="fa fa-info-circle mr-2 orange" />
                    <span class="title">Información de Estudiante(s)</span>
                  </span>
                  <StudentInfo
                    v-for="(item, index) in collections.searchResult"
                    :key="`row-item-${index}`"
                    :value="item"
                  />
                  <div class="row pt-2">
                    <div class="col-12 pt-0">
                      <pagination
                        v-if="pagination.totalItemCount > pagination.perPage"
                        :data="pagination"
                        :page-size="pagination.perPage"
                        @pagination-go-page="onPageChanged"
                      />
                    </div>
                  </div>
                </custom-tab-item>
                <custom-tab-item title="Historial" class="mt-2">
                  <span>
                    <i class="fa fa-info-circle mr-2 orange" />
                    <span class="title">Historial de Estatus</span>
                  </span>
                  <History :value="value.id" />
                </custom-tab-item>
                <custom-tab-item
                  v-if="value.status === 'Recomendado'"
                  title="Documentar Planteamiento de OGP"
                  class="mt-2"
                  :active="ogpActive"
                >
                  <span>
                    <i class="fa fa-info-circle mr-2 orange" />
                    <span class="title">Historial de Estatus</span>
                  </span>
                  <Ogp :request-id="value.id" @close="close" />
                </custom-tab-item>
              </custom-tab>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="isCancelOpen" #edition>
      <validation-observer>
        <div class="p-2">
          <div class="px-2 py-2 border-radius--light bg-white">
            <div class="w-100 p-3">
              <div class="col-12 mt-2">
                <label class="input-label">Comentario:</label>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="comment"
                  :rules="'required'"
                >
                  <CustomTextArea
                    :id="'comment'"
                    v-model="comment"
                    style="width: 100%"
                    :maxlength="3000"
                    :classes="['eq-field', 'text-right']"
                    :rows="5"
                    :error="errors[0]"
                    :custom-error-msg="'Favor escriba una descripción.'"
                  />
                </ValidationProvider>
              </div>

              <div class="col-12 justify-content-end d-flex my-3">
                <ActionButton
                  id="dispose"
                  variant="outline-danger mr-2"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  @click="dispose"
                />
                <ActionButton
                  id="saveReason"
                  variant="success"
                  text="Cambiar"
                  i="fas fa-save"
                  @click="saveReason"
                />
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </template>
  </CustomCallout>
</template>

<script>
import CustomCallout from "custom-callout";
import CustomBalloon from "custom-balloon";
import dropdown from "dropdown";
import { StudentInfo, History, Ogp } from "./tabs-history";
import Pagination from "pagination";
import { CustomTab, CustomTabItem } from "custom-tabs";
import { getRequeststudents } from "@/modules/human-resources/api";
import ActionButton from "ActionButton";
import {
  requestStatusCodes,
  getRequestStatusColor,
  requestStatusString
} from "@/utils/constants/hrrequest/requestStatusCodes";
import alert from "@/mixin/alert.mixin";
import CustomTextArea from "CustomTextArea";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "SearchResultRow",
  mixins: [alert],
  components: {
    CustomCallout,
    CustomTextArea,
    CustomBalloon,
    dropdown,
    StudentInfo,
    Pagination,
    History,
    CustomTab,
    CustomTabItem,
    Ogp,
    ActionButton,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      requestStatusCodes,
      getRequestStatusColor,
      isOpen: false,
      isVisible: false,
      isCancelOpen: false,
      ogpActive: false,
      targetStatusId: null,
      comment: null,
      collections: {
        searchResult: []
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0
      }
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    isSubmitted() {
      return this.value.statusId === requestStatusCodes.submitted;
    },
    isNew() {
      return this.value.statusId == requestStatusCodes.new;
    },
    isCanceled() {
      return this.value.statusId == requestStatusCodes.Cancelada;
    },
    isNotNew() {
      return (
        this.value.statusId != requestStatusCodes.new &&
        this.value.statusId != requestStatusCodes.returnedToSchool
      );
    },
    hasPermissionForChangeStatusToNew() {
      const canChangeStatus = this.$store.getters.HasPermission(
        "humanresources.irregularstaff.changestatustonew"
      );
      return canChangeStatus;
    },
    hasPermissionForChangeStatusToPrevious() {
      const canChangeStatus = this.$store.getters.HasPermission(
        "humanresources.irregularstaff.changestatustoprevious"
      );
      return canChangeStatus;
    },
    hasPermissionForDeleteNew() {
      const canDeleteNew = this.$store.getters.HasPermission(
        "humanresources.irregularstaff.deleterequest"
      );
      return canDeleteNew;
    }
  },
  async mounted() {
    this.onSearch();
  },
  methods: {
    getHRRequestActions() {
      const actions = [];
      const validStatusToCancel = [
        requestStatusCodes.submitted,
        requestStatusCodes.teacherFacilitatorAnalysisProcess,
        requestStatusCodes.returnedToSchool,
        requestStatusCodes.CSEEAnalysisProcess,
        requestStatusCodes.pendingCSEEAnalysis,
        requestStatusCodes.returnedToFacilitatorTeacher,
        requestStatusCodes.SAEEPendingAnalysis,
        requestStatusCodes.SAEEAnalysisProcess,
        requestStatusCodes.returnedToCSEEDirector
      ];

      actions.push({
        label: "Entrar",
        icon: "fas fa-clipboard-check color-primary-1",
        click: () => this.goToEdit()
      });

      if (this.isNotNew) {
        actions.push({
          label: "Imprimir",
          icon: "fas fa-print color-primary-1",
          click: () => this.printRequest()
        });
      }
      if (this.showIfContainStatus(validStatusToCancel, this.value.statusId)) {
        actions.push({
          label: "Cancelar",
          icon: "fas fa-times-square text-red",
          click: () => this.cancelAction()
        });
      }

      if (this.value.status === "Recomendado") {
        actions.push({
          label: "Documentar Planteamento de OGP",
          icon: "fas fa-folder color-primary-1",
          class: "border-y",
          click: () => this.openOGPtab()
        });
      }

      if (this.isSubmitted && this.hasPermissionForChangeStatusToNew) {
        actions.push({
          label: "Cambiar estatus a Nuevo",
          icon: "fas fa-repeat-alt color-primary-1",
          class: "border-y",
          click: () => this.changeRequestStatusToNew()
        });
      }

      if (
        (!this.isNew &&
        !this.isCanceled &&
        !this.isSubmitted) &&
        this.hasPermissionForChangeStatusToPrevious
      ) {
        actions.push({
          label: "Regresar al estatus anterior",
          icon: "fas fa-repeat-alt color-primary-1",
          class: "border-y",
          click: () => this.changeRequestStatusToPrevious()
        });
      }

      if (this.isNew && this.hasPermissionForDeleteNew) {
        actions.push({
          label: "Eliminar",
          class: "border-y",
          icon: "fas fa-times-circle text-red",
          click: () => this.delete()
        });
      }

      if (!this.isNew) {
        actions.push({
          label: "Historial",
          icon: "fas fa-history color-primary-1",
          click: () => this.goToHistory()
        });
      }

      return actions;
    },
    openOGPtab() {
      this.$refs.callout.isOpen = true;
      this.ogpActive = true;
    },
    async changeRequestStatusToNew() {
      const answer = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea cambiar el estatus de ${
          requestStatusString[this.value.statusId]
        } a ${requestStatusString[requestStatusCodes.new]}?`
      );

      if (answer) {
        const dto = {
          id: requestStatusCodes.new,
          description: requestStatusString[requestStatusCodes.new]
        };

        this.$emit("changeStatus", this.value.id, dto);
      }
    },
    async changeRequestStatusToPrevious() {
      const answer = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea regresar al estatus ${
          requestStatusString[this.value.previousStatusId]
        }?`
      );

      if (answer) {
        const dto = {
          previousStatusId: this.value.previousStatusId,
          description: requestStatusString[this.value.previousStatusId]
        };
        this.$emit("changeStatus", this.value.id, dto);
      }
    },
    async delete() {
      const answer = await this.ShowCancelModal(
        "Confirmación",
        "¿Está seguro que desea eliminar la solicitud?"
      );
      if (answer) {
        this.$emit("delete", this.value.id);
      }
    },
    goToEdit() {
      this.$router.push(`/humanres/request/edit/${this.value.id}`);
    },
    goToHistory() {
      this.$router.push(`/humanres/request/history/${this.value.id}`);
    },
    async printRequest() {
      this.$emit("printRequest", this.value.id);
    },
    async onSearch() {
      await getRequeststudents(this.value.id, this.pagination.currentPage).then(
        res => {
          this.collections.searchResult = res.data.data;
          this.pagination = {
            ...this.pagination,
            totalItemCount: res.data.totalItemCount,
            pageCount: res.data.pageCount,
            currentPage: res.data.currentPage,
            count: res.data.count
          };
        }
      );
    },
    close() {
      this.$refs.callout.isOpen = false;
    },
    async onPageChanged(currentPage) {
      this.pagination.currentPage = currentPage;
      this.onSearch();
    },

    dispose() {
      this.isCancelOpen = false;
      this.comment = null;
    },
    async cancelAction() {
      this.isCancelOpen = true;
    },

    async saveReason() {
      const answer = await this.ShowCancelModal(
        "Confirmación",
        `¿Estás seguro(a) que desea cancelar la solicitud ${this.value.number}?`
      );

      if (answer) {
        const dto = {
          id: requestStatusCodes.Cancelada,
          description: requestStatusString[requestStatusCodes.Cancelada],
          reason: this.comment ?? null
        };

        this.$emit("changeStatus", this.value.id, dto);
        this.dispose();
      }
    },
    showIfContainStatus(statuses, statusId) {
      return statuses.some(id => id === statusId);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";

.qpl {
  padding-left: 52px;
}

::v-deep .border-y {
  border-top: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
}

.pl-q {
  padding-left: 3rem;
}

.orange {
  color: #ff7058;
}

.divider-horizontal {
  border-right: 1px solid #e2e2e2;
}

.divider-vertical {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e2e2;
}

@media only screen and (max-width: 375px) {
  ::v-deep .ac-btn {
    width: 100%;
  }

  .pl-c {
    margin-left: 15px;
  }

  ::v-deep .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal !important;
  }

  ::v-deep .info-text {
    color: #11291b !important;
    font-weight: normal !important;
    font-size: 12px !important;
  }

  ::v-deep .balloon-container {
    font-size: 12px !important;
    width: 90% !important;
  }
}
::v-deep .balloon-container {
  width: 90% !important;
}

::v-deep .info-text-title {
  color: #727272;
  font-size: 16px;
  font-weight: normal;
}

::v-deep .info-text {
  color: #11291b;
  font-weight: normal;
  font-size: 16px;
  size: 16px;
}

::v-deep .dropdown-menu.dropdown-menu-right {
  width: auto !important;
}

::v-deep .balloon-container.green-light {
  background-color: $green_light !important;
}
</style>
